/**
 * @template T
 * Sets the value of a ref, whether that be an object with a `current` property, or a function.
 *
 * This is similar to the Material-UI implementation, however, theirs is marked private and may
 * potentially be tweaked to no longer be exported outside of their own code.
 *
 * @param {React.RefCallback<T> | React.MutableRefObject<T>} ref<T>
 * @param {T} value
 */
export function setRef(ref, value) {
    // Note: React ref's support both a function or object with `current` property. This is base behavior
    // in React, not something we bolted on after the fact.
    if (typeof ref === 'function') {
        ref(value);
    } else if (ref && typeof ref === 'object' && Object.prototype.hasOwnProperty.call(ref, 'current')) {
        ref.current = value;
    }
}
